import { z } from "zod";

export const UserSchema = z.object({
  id: z.number(),
  username: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  avatar: z.string(),
  verified: z.boolean(),
  sessionId: z.string(),
  lastAction: z.string(),
  loggedIn: z.boolean(),
  messageOnEmail: z.string(),
  phoneNumber: z.string(),
  mobileNumber: z.string(),
  defaultCurrency: z.string(),
  availableCurrencies: z.string(),
  importId: z.string(),
  importTyp: z.string(),
  language: z.string(),
  lastLoginDate: z.string(),
  lastLogoutDate: z.string(),
  failedLoginCounter: z.number(),
  lastFailedLogin: z.string(),
  defaultCallendarColor: z.string(),
  resetLinkExpires: z.string(),
  activeCurrency: z.string(),
  systemTheme: z.string(),
  isExternalLogin: z.boolean(),
  importCode: z.string(),
  modificationDate: z.string(),
  msexchange: z.string(),
  uri: z.string(),
  fullName: z.string(),
});

export type User = z.infer<typeof UserSchema>;
